import { render } from "./TermConditions.vue?vue&type=template&id=8b1cfc36"
import script from "./TermConditions.vue?vue&type=script&lang=js"
export * from "./TermConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__